(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["communityhero"] && !Shopify.designMode) return;
  try {
    
  const podcastHero = document.getElementById('podcast-hero');
  const iso = podcastHero.dataset.iso;
  const pageLanguage = podcastHero.dataset.language;
  const alternativePages = JSON.parse(podcastHero.dataset.pages);

  if (iso !== pageLanguage && !Shopify.designMode) {
    const matchingPage = alternativePages.find(page => page.language === iso);

    if (matchingPage) {
      window.location.href = matchingPage.url;
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["podcast-hero"] && !Shopify.designMode) return;
  try {
    
  const podcastHero = document.getElementById('podcast-hero');
  const iso = podcastHero.dataset.iso;
  const pageLanguage = podcastHero.dataset.language;
  const alternativePages = JSON.parse(podcastHero.dataset.pages);

  if (iso !== pageLanguage && !Shopify.designMode) {
    const matchingPage = alternativePages.find(page => page.language === iso);

    if (matchingPage) {
      window.location.href = matchingPage.url;
    }
  }

  } catch(e) { console.error(e); }
})();
})();
